import React from "react";
import PropTypes from "prop-types";
import { gatherClasses } from "../../lib/utils";
import SmallMessageBox from "./smallMessage";
import RegularMessageBox from "./regularMessage";
import "./messageBox.scss";

const MessageBox = ({ size, dataTestId, ...props }) => {
  return (
    <div
      data-testid={dataTestId}
      className={gatherClasses(props, "oui-message-box")}
    >
      {size === "sm" ? (
        <SmallMessageBox {...props} />
      ) : (
        <RegularMessageBox size={size} {...props} />
      )}
    </div>
  );
};

MessageBox.defaultProps = {
  size: "md",
  dataTestId: "orion-message-box"
};

MessageBox.propTypes = {
  size: PropTypes.string,
  dataTestId: PropTypes.string
};

MessageBox.displayName = "OrionMessageBox";

export default MessageBox;
